export enum Trigger {
  HOVER = 'hover',
  FOCUS = 'focus',
  TOUCH = 'touch',
  CLICK = 'click',
  BLUR = 'blur'
}
